import React from "react"
import { useTranslation } from "react-i18next"
import {
 AlertDialog,
 AlertDialogAction,
 AlertDialogCancel,
 AlertDialogContent,
 AlertDialogDescription,
 AlertDialogFooter,
 AlertDialogHeader,
 AlertDialogTitle,
} from "./ui/alert-dialog"
import { buttonVariants } from "./ui/button"
import { cn } from "../lib/utils"
interface DeleteConfirmDialogProps {
 open: boolean
 onOpenChange: (open: boolean) => void
 onConfirm: () => void
 /** Called when user presses cancel (not when dialog closes after confirm). */
 onCancel?: () => void
 title?: string
 description?: string
 confirmText?: string
 cancelText?: string
 loading?: boolean
}

export function DeleteConfirmDialog({
 open,
 onOpenChange,
 onConfirm,
 onCancel,
 title,
 description,
 confirmText,
 cancelText,
 loading = false,
}: DeleteConfirmDialogProps) {
 const { t } = useTranslation()
 const resolvedTitle = title ?? t('ui.deleteConfirmTitle')
 const resolvedDescription = description ?? t('ui.deleteConfirmDescription')
 const resolvedConfirmText = confirmText ?? t('ui.delete')
 const resolvedCancelText = cancelText ?? t('ui.cancel')

 return (
 <AlertDialog open={open} onOpenChange={onOpenChange}>
 <AlertDialogContent>
 <AlertDialogHeader>
 <AlertDialogTitle>{resolvedTitle}</AlertDialogTitle>
 <AlertDialogDescription>{resolvedDescription}</AlertDialogDescription>
 </AlertDialogHeader>
 <AlertDialogFooter>
 <AlertDialogCancel
 disabled={loading}
 onClick={() => onCancel?.()}
 >
 {resolvedCancelText}
 </AlertDialogCancel>
 <AlertDialogAction
 onClick={onConfirm}
 className={cn(buttonVariants({ variant:"destructive"}))}
 disabled={loading}
 >
 {loading ? t('ui.deleting') : resolvedConfirmText}
 </AlertDialogAction>
 </AlertDialogFooter>
 </AlertDialogContent>
 </AlertDialog>
 )
}
